/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
==========================================================================================*/

import moment from "moment-business-days";

export default [
  {
    header: 'Wood Finder',  // Stock
    icon: 'SearchIcon',
    i18n: 'Wood Finder',
    items: [
      {
        url: '/woodfinder',
        name: 'WoodFinder',  // Stock
        tagColor: 'primary',
        icon: 'SearchIcon',
        i18n: 'Wood Finder',
      },
      {
        url: '/customerfinder',
        name: 'Customer Finder',
        tagColor: 'primary',
        icon: 'TargetIcon',
        i18n: 'Customer Finder',
      },
    ],
  }
]